import { isNullish } from '@/libs/utils'
import { defineRule } from '../define-rule'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type RequiredRuleConstructorParams = BaseRuleConstructorParams<undefined>

export const required = defineRule(
  'required',
  ({ errorMessage }: RequiredRuleConstructorParams) => {
    const error = errorMessage ?? false
    return (value: unknown) => {
      if (isNullish(value)) return error
      if (typeof value === 'string') return value.length > 0 || error
      if (Array.isArray(value)) return value.length > 0 || error
      return true
    }
  }
)
